var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"1000px","src":_vm.isFranchiseOrHigher
        ? 'https://lookerstudio.google.com/embed/reporting/b9c519de-ec59-491e-902e-d22a4f2dba08/page/p_ca91o4pj2c'
        : 'https://lookerstudio.google.com/embed/reporting/0dd88a24-0525-4bd7-b612-a3b745ce8ac8/page/p_ca91o4pj2c',"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }